import React from 'react';

import styles from './styles.module.scss';
import {TopElement} from '../TopElement';
import {featuresLinks} from '../../../constants/links';

import {AntiWebhookFeature} from '../../Cards/AntiWebhookFeature';

export const AntiWebhook = () => {
  return (
    <div className={styles.wrapper}>
      <TopElement
        title="Anti-Webhook"
        subTitle="Prevents server members from using webhooks without permission. The algorithm is based on
        several indicators that indicate the possibility of a malicious webhook being created."
        labelTitle="Anti-Webhook Tutorial"
        labelLInk={featuresLinks.antiWebHook}
      />
      <div className={styles.block}>
        <AntiWebhookFeature />
      </div>
    </div>
  );
};
